<template>
  <!-- <HeaderSection/> -->
  <LoadingSection v-if="is_loading || is_preloading" class="z-50" />

  <div class="flex flex-col min-h-screen w-full">
    <!-- Header image -->
    <div>
      <img src="https://resource.pafcpic.net/assets/funrun/papsi_run_header.jpg" class="w-full" />
    </div>

    <!-- Main content area -->
    <div class="flex-1 flex flex-col">
      <ProgressBarControl v-if="$route.path !== '/'" />
      <transition name="slide-in" mode="out-in">
        <router-view class="flex-1" />
      </transition>
    </div>

    <!-- Footer always at the bottom -->
    <FooterSection />
  </div>
</template>



<script>
// import HeaderSection from './components/sections/HeaderSection.vue';
import LoadingSection from './components/sections/LoadingSection.vue';
import FooterSection from './components/sections/FooterSection.vue';
import ProgressBarControl from './components/controls/ProgressBarControl.vue';
import user from './services/user';

export default {
  name: 'App',
  components: {
    LoadingSection,
    ProgressBarControl,
    FooterSection,
  },
  data() {
    return {
      is_loading: false,
      is_preloading: true,
      imagesToPreload: [
        'https://resource.pafcpic.net/assets/funrun/papsi_run_header.jpg',
        'https://resource.pafcpic.net/assets/funrun/npc_seal.png',
        'https://resource.pafcpic.net/assets/funrun/papsi_run_poster.jpg',
      ],
    };
  },
  provide() {
    return {
      setLoading: this.setLoading,
    };
  },
  mounted() {
    this.initLoad();
  },
  methods: {
    setLoading(status) {
      this.is_loading = status;
    },

    async initLoad() {
      this.is_preloading = true;

      // Run both API and image preload at the same time
      try {
        await Promise.all([this.preloadAllImages(), this.getRunSched()]);
        console.log('✅ All images and API data loaded successfully');
      } catch (err) {
        console.warn('⚠️ Some preload tasks failed:', err);
      } finally {
        this.is_preloading = false;
      }
    },

    preloadAllImages() {
      const promises = this.imagesToPreload.map((src) => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = reject;
        });
      });
      return Promise.all(promises);
    },

    getRunSched() {
      return user.getSched()
        .then((response) => {
          const schedData = response.data.data[0];
          this.$store.state.sched = schedData;
          console.log('✅ Schedule stored in Vuex:', schedData);
          return schedData; // Return it for possible later use
        })
        .catch((error) => {
          console.log('❌ Failed to load schedule:', error);
          throw error;
        });
    },
  },
};
</script>


<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Poppins, sans-serif;
  color: #2c3e50;
}

button:hover,
.tab:hover {
  filter: brightness(1.1) !important;
}

/* Transition for Pages */
.slide-in-enter-active,
.slide-in-leave-active {
  transition: transform 0.3s ease;
}

.slide-in-enter-from {
  transform: translateY(-30px);
  opacity: 0;
}

.slide-in-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.slide-in-leave-to {
  transform: translateY(-30px);
  opacity: 0;
}

.gap-2 {
  gap: 0.5rem; /* 16px */
}
.gap-3 {
  gap: 1rem; /* 16px */
}
.gap-4 {
  gap: 1rem; /* 16px */
}

.gap-5 {
  gap: 1.5rem; /* 24px */
}

.gap-6 {
  gap: 2rem; /* 32px */
}
.gap-10 {
  gap: 4rem; /* 32px */
}

/* Horizontal spacing between direct children */
.space-x-2 > :not([hidden]) ~ :not([hidden]) {
  margin-left: 0.5rem; /* 8px */
}

.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  margin-left: 0.75rem; /* 12px */
}

.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  margin-left: 1rem; /* 16px */
}

/* Vertical spacing between direct children */
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.5rem; /* 8px */
}

.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.5rem; /* 8px */
}

.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 0.75rem; /* 12px */
}

.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 1rem; /* 16px */
}

.leading-normal {
  line-height: 1.5 !important;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

input:focus {
  outline: none;
  border-color: #016B00 !important;
  box-shadow: none !important;
}

.rotate-180 {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
}

.rotate-0 {
    transform: rotate(0deg);
    transition: transform 0.3s ease;
}

</style>
